module.exports = __webpack_public_path__ + "static/hc2-layers-cover-9a56b38ac7cf2800839f2d30cd50349a.jpg";